exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1Fuk {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center; }\n\n._3FKm {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  max-width: 1400px;\n  width: 100%;\n  padding: 16px; }\n\n._12tU {\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #fff;\n  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);\n  height: 70vh;\n  width: 100%; }\n\n.oPd0 {\n  padding: 32px; }\n", ""]);

// exports
exports.locals = {
	"container": "_1Fuk",
	"mainContent": "_3FKm",
	"categoryFormWrapper": "_12tU",
	"categoryForm": "oPd0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/pages/Admin/Categories/CategoryNew/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/pages/Admin/Categories/CategoryNew/styles.scss
// module chunks = 0